export const GET_LOADER = "GET_LOADER"
export const PROFILE_INFO = "PROFILE_INFO"
export const SIDEMENU_SHOW = "SIDEMENU_SHOW"
export const CHILD_BID = "CHILD_BID"
